import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APPSTORE_URL } from "../../constants";
import { Button } from "../button";
// import { Button } from "../button";
import { Icon } from "../Icon/icon";

const navs = [
  {
    title: (
      <p className="flex gap-1 items-center">
        Products
        <Icon svg={"caret-down"} width={18} height={18} />
      </p>
    ),
    to: "/#products",
    subLinks: [
      { title: <p>Savings</p>, to: "/#savings" },
      { title: <p>Loans</p>, to: "/#loans" },
      { title: <p>Buzz</p>, to: "/#buzz" },
    ],
  },
  {
    title: <p>About</p>,
    to: "/about",
    internal: true,
  },
  {
    title: <p>Blog</p>,
    to: "/blog",
    internal: true,
  },
  {
    title: <p>FAQs</p>,
    to: "/faqs",
    internal: true,
  },
  {
    title: (
      <Button
        type="button"
        variation="white"
        className="!border-primary text-primary border"
        text="Sign Up"
      />
    ),
    to: APPSTORE_URL,
  },
  {
    title: <Button type="button" variation="primary" text="Sign In" />,
    to: APPSTORE_URL,
  },
];
export const NavBar = ({ className = "" }) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showSubLinks, setShowSubLinks] = useState(false);
  const handleToggle = () => {
    setShowSubLinks(!showSubLinks);
  };
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/" && hash && document.querySelector(hash) != null) {
      const scrollElement = document.querySelector(hash);
      scrollElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [hash, pathname]);

  return (
    <div
      className={`
        bg-white
        flex justify-center
        sticky top-0 z-[999]
        py-4 md:py-6
        border-b border-grey-200
        ${className}
        transition-all duration-500
      `}
    >
      <div className={`max-width items-center justify-between gap-2 flex `}>
        <Link to="/" className="w-fit">
          <img
            src="/logo.svg"
            alt="logo"
            className="max-w-[80px] md:max-w-[109px] block"
          />
        </Link>

        <div className="flex items-center gap-4">
          <nav className="xl:flex items-center font-medium text-lg hidden [&>a:nth-child(4)]:mr-7">
            {navs.map((nav, idx) => {
              if (nav.subLinks)
                return (
                  <div
                    key={idx.toString() + nav.to}
                    className="w-fit px-4 py-[10px] cursor-pointer inline-block relative"
                    onClick={handleToggle}
                  >
                    <span>{nav.title}</span>
                    {showSubLinks ? (
                      <div className="absolute bg-white rounded-2xl inline-flex flex-col gap-4 px-4 py-2">
                        {nav.subLinks.map(({ title, to, internal }) => {
                          return internal ? (
                            <Link
                              className="w-full"
                              key={`${idx}-${title}-${to}`}
                              to={to}
                            >
                              {title}
                            </Link>
                          ) : (
                            <a
                              className="w-full"
                              key={`${idx}-${title}`}
                              href={to}
                            >
                              {title}
                            </a>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                );
              return nav.internal ? (
                <Link
                  className="w-fit px-4 py-[10px]"
                  key={`${idx}`}
                  to={nav.to}
                >
                  {nav.title}
                </Link>
              ) : (
                <a
                  className="w-fit px-2 py-[10px]"
                  key={`${idx}`}
                  href={nav.to}
                >
                  {nav.title}
                </a>
              );
            })}
          </nav>

          {/* <Button
            text={"GET THE APP"}
            extra={
              <Icon svg={"stores"} width={53} height={26} className={"ml-2"} />
            }
            variation="deep-primary"
            className="hidden md:flex"
          /> */}

          <button
            className="w-fit md:hidden"
            type="button"
            aria-label="Open navigation menu"
            aria-expanded={showMobileMenu}
            onClick={() => setShowMobileMenu(true)}
          >
            <Icon svg={"hamburger"} width={28} height={28} />
          </button>
        </div>
      </div>

      {showMobileMenu ? (
        <div className="fixed inset-0 z-[1000] flex min-h-screen w-full flex-col bg-white md:hidden">
          <div className="flex h-[68px] shrink-0 items-center justify-between border-b border-[rgba(240,210,140,0.2)] bg-[#FEFBF4] px-4">
            <Link
              to="/"
              className="w-fit"
              onClick={() => setShowMobileMenu(false)}
            >
              <img
                src="/logo.svg"
                alt="MyCardGlobal"
                className="block h-9 w-[86px] object-contain"
              />
            </Link>
            <button
              type="button"
              aria-label="Close navigation menu"
              onClick={() => setShowMobileMenu(false)}
              className="flex h-7 w-7 items-center justify-center rounded-full bg-[#23272E] text-lg leading-none text-white"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <nav className="flex w-[164px] flex-col gap-10 pl-[41px] pt-[58px] text-[18px] text-black">
            <Link to="/about" onClick={() => setShowMobileMenu(false)}>
              About
            </Link>

            <div className="flex w-[164px] flex-col gap-4">
              <button
                type="button"
                className="flex w-full items-center justify-between text-left"
                aria-expanded={showSubLinks}
                onClick={handleToggle}
              >
                <span>Products</span>
                <Icon
                  svg="caret-down"
                  width={18}
                  height={18}
                  className={showSubLinks ? "rotate-180" : ""}
                />
              </button>
              {showSubLinks ? (
                <div className="flex flex-col gap-4 text-[#1D2939]">
                  <a href="#savings" onClick={() => setShowMobileMenu(false)}>
                    Savings
                  </a>
                  <a href="#loans" onClick={() => setShowMobileMenu(false)}>
                    Loans
                  </a>
                  <a href="#buzz" onClick={() => setShowMobileMenu(false)}>
                    Buzz
                  </a>
                </div>
              ) : null}
            </div>

            <Link to="/blog" onClick={() => setShowMobileMenu(false)}>
              Blogs
            </Link>
            <Link to="/faqs" onClick={() => setShowMobileMenu(false)}>
              FAQs
            </Link>
          </nav>
        </div>
      ) : null}
    </div>
  );
};
